import { PageId } from 'constants/pages'
import { PaymentSystem } from 'nove8/constants/root-constants'
import {
  PURCHASE_REDIRECT_SEARCH_PARAMS,
  removePurchaseRedirectSearchParams,
} from 'nove8/helpers/purchaseRedirectSearchParams'
import { useEffect } from 'react'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'

const PAYMENT_SYSTEMS = [
  PaymentSystem.PAYPAL,
  PaymentSystem.STRIPE,
  PaymentSystem.STRIPE_CS,
  PaymentSystem.STRIPE_PAYPAL,
]

const isPaymentSystem = (value: string): value is PaymentSystem =>
  PAYMENT_SYSTEMS.includes(value as PaymentSystem)

export const useRestorePurchaseFromSearchParams = (): void => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const purchaseId = searchParams.get(
      PURCHASE_REDIRECT_SEARCH_PARAMS.purchaseId,
    )
    const purchasePageId = searchParams.get(
      PURCHASE_REDIRECT_SEARCH_PARAMS.purchasePageId,
    )
    const paymentSystem = searchParams.get(
      PURCHASE_REDIRECT_SEARCH_PARAMS.paymentSystem,
    )
    const paymentMethod = searchParams.get(
      PURCHASE_REDIRECT_SEARCH_PARAMS.paymentMethod,
    )
    const hasPurchaseRedirectSearchParams = Object.values(
      PURCHASE_REDIRECT_SEARCH_PARAMS,
    ).some((searchParam) => searchParams.has(searchParam))

    if (!hasPurchaseRedirectSearchParams) return

    if (
      purchaseId &&
      purchasePageId &&
      paymentSystem &&
      paymentMethod &&
      isPaymentSystem(paymentSystem)
    ) {
      useZustandGlobalLocalStore.setState({
        purchaseId,
        purchasePageId: purchasePageId as PageId,
        paymentSystem,
        lastUsedPaymentMethod: paymentMethod,
      })
    }

    removePurchaseRedirectSearchParams()
  }, [])
}
